import { Component, Input, ChangeDetectionStrategy, ElementRef, Renderer2 } from '@angular/core';
var NglFigure = (function () {
    function NglFigure(element, renderer) {
        this.element = element;
        this.renderer = renderer;
        this.title = null;
    }
    NglFigure.decorators = [
        { type: Component, args: [{
                    selector: 'figure[nglFigure]',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: "\n    <ng-content></ng-content><figcaption class=\"slds-image__title slds-image__title--card\" *ngIf=\"title\"><span class=\"slds-image__text slds-truncate\" [attr.title]=\"title\">{{title}}</span></figcaption>\n  ",
                    host: {
                        '[class.slds-image]': 'true',
                        '[class.slds-image--card]': 'true',
                    },
                },] },
    ];
    /** @nocollapse */
    NglFigure.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: Renderer2, },
    ]; };
    NglFigure.propDecorators = {
        'title': [{ type: Input, args: ['nglTitle',] },],
    };
    return NglFigure;
}());
export { NglFigure };
;
//# sourceMappingURL=figure.js.map